import React from 'react';
import './css/Link.css';

export default class Link extends React.Component{
  constructor(props) {
    super(props);
    this.state = {}
  }

  onClickHandler(e, url){
    e.preventDefault();
    this.props.ir(url);
  }

  render(){
    const {titulo, color, url} = this.props;
    return(
      <a
        className="OpcionLink"
        style={{backgroundColor:color}}
        href={url}
        onClick={(e) => this.onClickHandler(e, url)}
      >
        {titulo}
      </a>
    )
  }
}

/*
import {Link} from '../comun/Index';

<Link
  titulo=""
  color=""
  url=""
  ir={(url) => this.props.history.push(url)}
/>
*/
